import { createTheme, ThemeOptions } from "@mui/material";
import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { themeBase } from "./_themeBase";

const theme: ThemeOptions = {
  palette: {
    primary: {
      main: "#5568A0",
      dark: "#213F6D",
      light: "#BDBBBB",
      base: "#B7C1DE",
      accent: "#A8B94D",
    },
    components: {
      slider: {
        rail: "#B7C1DE",
        track: "#213F6D",
        thumbIcon: "#F2704F",
        label: "#213F6D",
      },
      progressBar: {
        rail: "#B7C1DE",
        track: "#213F6D",
      },
      phoneInput: {
        main: "#B7C1DE",
      },
      buttonSelect: {
        backgroundColor: "#D8D8D8D8",
        textColor: "#333F48",
        backgroundColorActive: "#5568A0",
        textColorActive: "#FFFFFF",
        bordeColorActive: "#5568A0",
      },
    },
    // screens: {
    //   bofu: {
    //     backgroundColor: "#FFFFFF",
    //     titleColor: "#49A942",
    //     subtitleColor: "#2C2C2C",
    //     iconColor: "#49A942",
    //   },
    // },
  },
};

export const CustomTheme = createTheme(themeBase, theme);

export const interfaceConfig: InterfaceConfig = {
  name: "providencia",
  home_url: "/solicita_tu_credito",
  aviso_privacidad: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  interest_rate: 30,
  metadata: {
    title: "CasoFin",
    description:
      "Lendia es una plataforma de crédito para PyMEs que ofrece créditos especializados para PyMEs con tasas competitivas y procesos ágiles. Obtén el financiamiento que tu empresa necesita para crecer.",
    favicon: "casofin/portal/logos/favicon.ico",
    ogImage: "https://lendia.mx/opengraph-image.png?5ab5b324c6780cbc",
  },
  navbar: {
    logo: "casofin/portal/logos/logo.png",
    logo_width: 110,
    logo_height: 40,
    logo_menu_lateral: "providencia/portal/logos/logo_menu_lateral.svg",
  },
  lateral: {
    logo_width: 250,
    logo_height: 50,
    logo_dark: "casofin/portal/logos/logo_dark.png",
    bg_light: "#5568A0",
    text_light: "#FFFFFF",
    logo_light: "casofin/portal/logos/logo_light.png",
    bg_dark: "#213F6D",
    text_dark: "#FFFFFF",
    image_list: [
      "casofin/portal/lateral/imagen_1.webp",
      "casofin/portal/lateral/imagen_2.webp",
      "casofin/portal/lateral/imagen_3.webp",
      "casofin/portal/lateral/imagen_4.webp",
      "casofin/portal/lateral/imagen_5.webp",
      "casofin/portal/lateral/imagen_6.webp",
      "casofin/portal/lateral/imagen_7.webp",
      "casofin/portal/lateral/imagen_8.webp",
      "casofin/portal/lateral/imagen_9.webp",
      "casofin/portal/lateral/imagen_10.webp",
    ],
    text_list: [
      "Así de fácil: solicita, compara, avanza",
      "Tu crédito, tu elección, tu crecimiento",
      "Crédito simple, procesos simples",
      "Avanza con las mejores condiciones del mercado",
      "Compara y decide: tu crédito, tus reglas",
      "Un solo lugar, todas las opciones de financiamiento",
      "Crecer nunca fue tan sencillo",
      "Descubre la mejor solución para tu PyME",
      "El poder de elegir está en tus manos",
      "Da el paso que tu empresa necesita",
    ],
  },
  textos_tofu: {
    pm: {
      crear_cuenta: {
        titulo: "Te damos la bienvenida",
        sub_titulo: "",
      },
      registro_datos_personales: {
        titulo: "Creación de cuenta",
        sub_titulo: "",
      },
      validacion_telefono: {
        titulo: "Validación de teléfono",
        sub_titulo: "",
      },
      datos_empresa_pm: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      consulta_ciec: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      uso_de_credito: {
        titulo: "Selección de uso de crédito",
        sub_titulo: "",
      },
      presencia_digital_pm: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
      datos_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      rfc_curp: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      domicilio_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      consulta_buro_nip: {
        titulo: "Validación para consulta buró",
        sub_titulo: "",
      },
      buro_bloqueado: {
        titulo: "Consulta de Buró de Crédito del Accionista Bloqueada",
        sub_titulo: "",
      },
    },

    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
      consulta_buro_pfae: {
        titulo: "Consulta Buró",
        sub_titulo: "",
      },
      domicilio_pfae: {
        titulo: "Domicilio",
        sub_titulo: "",
      },
      presencia_digital_pfae: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
    },
  },
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyDAtCLTqWu3XTjTC6AT2ZysdXUtL33bAX4"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: ["Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_xNemClkcb",
      userPoolClientId: "43gc1fvrdk55b6j4g5nq6k21vo",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_FhHFierzr",
      userPoolClientId: "5qvl9t4n2qtvg99rv30t6gqqum",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
